(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LcapLogin", [], factory);
	else if(typeof exports === 'object')
		exports["LcapLogin"] = factory();
	else
		root["LcapLogin"] = factory();
})(window, function() {
return 